function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentColor",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("circle", {
  cx: 11,
  cy: 10,
  r: 7
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.942 14.942l5.04 5.04"
}));
function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _ref);
}
export default SvgSearch;